module.exports = __webpack_public_path__ + "static/media/levels_3_1.906679d6.svg";